import { render, staticRenderFns } from "./zonasTabs.vue?vue&type=template&id=ec372272"
import script from "./zonasTabs.vue?vue&type=script&lang=js"
export * from "./zonasTabs.vue?vue&type=script&lang=js"
import style0 from "./zonasTabs.vue?vue&type=style&index=0&id=ec372272&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports